// Imports
import axios from "axios";
import { routesApi } from "../../../../setup/routes";

// Actions Types
export const ECONOMIC_ANALYSIS_REQUEST = "ECONOMIC_ANALYSIS_REQUEST";
export const ECONOMIC_ANALYSIS_RESPONSE = "ECONOMIC_ANALYSIS_RESPONSE";
export const ECONOMIC_ANALYSIS_FAILURE = "ECONOMIC_ANALYSIS_FAILURE";
export const REGISTER_ECONOMIC_ANALYSIS_REQUEST = "REGISTER_ECONOMIC_ANALYSIS_REQUEST";
export const REGISTER_ECONOMIC_ANALYSIS_RESPONSE = "REGISTER_ECONOMIC_ANALYSIS_RESPONSE";
export const REGISTER_ECONOMIC_ANALYSIS_FAILURE = "REGISTER_ECONOMIC_ANALYSIS_FAILURE";
export const EDIT_ECONOMIC_ANALYSIS_REQUEST = "EDIT_ECONOMIC_ANALYSIS_REQUEST";
export const EDIT_ECONOMIC_ANALYSIS_RESPONSE = "EDIT_ECONOMIC_ANALYSIS_RESPONSE";
export const EDIT_ECONOMIC_ANALYSIS_FAILURE = "EDIT_ECONOMIC_ANALYSIS_FAILURE";
export const MONTH_ECONOMIC_ANALYSIS_REQUEST = "MONTH_ECONOMIC_ANALYSIS_REQUEST";
export const MONTH_ECONOMIC_ANALYSIS_RESPONSE = "MONTH_ECONOMIC_ANALYSIS_RESPONSE";
export const MONTH_ECONOMIC_ANALYSIS_FAILURE = "MONTH_ECONOMIC_ANALYSIS_FAILURE";
export const ADD_MONTHLY_BILLING_REQUEST = "ADD_MONTHLY_BILLING_REQUEST";
export const ADD_MONTHLY_BILLING_RESPONSE = "ADD_MONTHLY_BILLING_RESPONSE";
export const ADD_MONTHLY_BILLING_FAILURE = "ADD_MONTHLY_BILLING_FAILURE";

// Actions

// export function getByProject(projectId, periodId, token, isLoading = true) {
//   return async dispatch => {
//     dispatch({
//       type: ECONOMIC_ANALYSIS_REQUEST,
//       isLoading
//     });
//     try {
//       const headers = { Authorization: `Bearer ${token}` };
//       const payload = { projectId, periodId };
//       const request = axios.post(routesApi.economicAnalysis.base, payload, {
//         headers
//       });
//       const response = await request;
//       return dispatch({
//         type: ECONOMIC_ANALYSIS_RESPONSE,
//         economicAnalysis: response.data.economicAnalysis
//       });
//     } catch (error) {
//       return dispatch({
//         type: ECONOMIC_ANALYSIS_FAILURE,
//         error: true,
//         errorMessage: error.response.data.error
//       });
//     }
//   };
// }

export function create(payload, token, isLoading = true) {
  return async dispatch => {
    dispatch({
      type: REGISTER_ECONOMIC_ANALYSIS_REQUEST,
      isLoading
    });
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const request = axios.post(routesApi.economicAnalysis.base, payload, { headers });
      const response = await request;
      return dispatch({
        type: REGISTER_ECONOMIC_ANALYSIS_RESPONSE,
        created: response.data.economicAnalysis
      });
    } catch (error) {
      return dispatch({
        type: REGISTER_ECONOMIC_ANALYSIS_FAILURE,
        error: true,
        errorMessage: error.response.data.error
      });
    }
  }
}

export function edit(payload, token, isLoading = true) {
  return async dispatch => {
    dispatch({
      type: EDIT_ECONOMIC_ANALYSIS_REQUEST,
      isLoading
    });
    try {
      const headers = { Authorizarion: `Bearer ${token}` };
      const request = axios.put(routesApi.economicAnalysis.base, payload, { headers });
      const response = await request;
      return dispatch({
        type: EDIT_ECONOMIC_ANALYSIS_RESPONSE,
        edited: response.data.economicAnalysis
      });
    } catch (error) {
      return dispatch({
        type: EDIT_ECONOMIC_ANALYSIS_FAILURE,
        error: true
      });
    }
  }
}

export function addMonthlyBilling(payload, token, isLoading = true) {
  return async dispatch => {
    dispatch({
      type: ADD_MONTHLY_BILLING_REQUEST,
      isLoading
    });
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const request = axios.put(routesApi.economicAnalysis.addMonthlyBilling, payload, { headers });
      const response = await request;
      return dispatch({
        type: ADD_MONTHLY_BILLING_RESPONSE,
        rowsModified: response.data.addBillingPerMonth
      });
    } catch (error) {
      return dispatch({
        type: ADD_MONTHLY_BILLING_FAILURE,
        error: true,
        errorMessage: error.response.data.error
      });
    }
  }
}
